import * as React from 'react';
var RcsCard = () => {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "1em",
    viewBox: "0 0 36 36",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 25.875C6 28.1532 7.84683 30 10.125 30H25.875C28.1532 30 30 28.1532 30 25.875V10.125C30 7.84683 28.1532 6 25.875 6H10.125C7.84683 6 6 7.84682 6 10.125V25.875ZM10.125 27.75C9.08947 27.75 8.25 26.9105 8.25 25.875V10.125C8.25 9.08947 9.08947 8.25 10.125 8.25H25.875C26.9105 8.25 27.75 9.08947 27.75 10.125V25.875C27.75 26.9105 26.9105 27.75 25.875 27.75H10.125Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.375 23.625C6.375 24.2463 6.87868 24.75 7.5 24.75H28.5C29.1213 24.75 29.625 24.2463 29.625 23.625C29.625 23.0037 29.1213 22.5 28.5 22.5H7.5C6.87868 22.5 6.375 23.0037 6.375 23.625Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
export default RcsCard;